import React, { forwardRef } from 'react';
import MaskedInput from 'react-text-mask';

const CPFMaskInput = forwardRef(({ value, onChange, ...rest }, ref) => {
    const cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    return (
        <MaskedInput
            mask={cpfMask}
            value={value}
            onChange={onChange}
            render={(inputRef, props) => (
                <input ref={inputRef} {...props} {...rest} className="form-control" />
            )}
        />
    );
});

export default CPFMaskInput;
